export const profile = {
    name: 'Simon Turner',
    email: 'sturner40@gmail.com',
    siteUrl: 'https://simonturnerdev.co.uk',
    siteLabel: 'simonturnerdev.co.uk',
    linkedinUrl: 'https://www.linkedin.com/in/simon-turner-development/',
    cvPath: '/curriculum-vitae',
    /** The downloadable CV. The CV page's own download link points at the same file. */
    cvPdfPath: '/docs/simon-t-cv.pdf',
} as const;

export const mailto = `mailto:${profile.email}`;
